import { Modal } from "bootstrap"

function _ytbThumbnails(videoID) {
	function thumbnail(thumbnailSize, width, height) {
		return {
			size: thumbnailSize,
			url: `https://i.ytimg.com/vi/${videoID}/${thumbnailSize}.jpg`,
			width,
			height
		}
	}

	return [
		thumbnail('maxresdefault', 1280, 720),
		thumbnail('sddefault', 640,  480),
		thumbnail('hqdefault', 480,  360),
		thumbnail('mqdefault', 320,  180),
		thumbnail('default', 120,  90),
	]
}

export default class VideoYoutube {
	constructor(url) {

		// Setando os attrs
		this.url        = url
		this.videoId    = this.extractID(url)
		this.thumbnails = _ytbThumbnails(this.videoId)

		// Conferindo/Criando os static values
		if(!VideoYoutube.connected) VideoYoutube.setConnection()

		if(!VideoYoutube.modal) VideoYoutube.createModal()
	}

	createIframe() {
		const url = new URL(`https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.videoId)}`)
		const iframe = document.createElement('iframe')

		url.searchParams.append('autoplay', '1')
		url.searchParams.append('rel', '0')

		iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
		iframe.allowFullscreen = true
		iframe.src = url.toString()

		return iframe
	}

	extractID(url) {
        const regex = /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?\/)|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i;
        const match = url.match(regex);

        if (match) {
            return match[1];
        }

        return null
    }

	static createModal() {
		const modalEl = document.createElement('div')

		modalEl.classList.add('modal', 'modal__ytb')
		modalEl.id = 'modalYTB'

		modalEl.innerHTML = `<div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
                </div>
                <div class="modal-body"></div>
            </div>
        </div>`

		VideoYoutube.modalEl   = modalEl
		VideoYoutube.modalBody = modalEl.querySelector('.modal-body')
		VideoYoutube.modal     = new Modal(modalEl)

		document.body.appendChild(modalEl)

		// Reseta o modal ao fechá-lo
		modalEl.addEventListener('hidden.bs.modal', () => VideoYoutube.modalBody.innerHTML = '')
	}

	static setConnection() {
		VideoYoutube.addPrefetch('https://www.youtube-nocookie.com', 'preconnect')
		VideoYoutube.addPrefetch('https://i.ytimg.com', 'preconnect')

		VideoYoutube.connected = true
	}

	static addPrefetch(href, rel, as) {
		const link = document.createElement('link')

		link.href = href
		link.rel = rel

		if(as) link.as = as

		document.head.appendChild(link)
	}
}
